import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';

const LeaveTrackerLayout = () => {
  const isManager = localStorage.getItem('role_id') === '3';
  const isAdmin = localStorage.getItem('role_id') === '1';

  return (
    <div className="w-full">
      <div className="flex gap-6 border-b mb-6">
        {(isManager || isAdmin) && <NavLink
          to="/leavetracker/team"
          className={({ isActive }) =>
            `px-4 py-2 font-semibold border-b-2 transition-colors ${isActive ? 'border-blue-600 text-blue-700 bg-blue-50' : 'border-transparent text-gray-700 hover:bg-gray-100'}`
          }
        >
          Team
        </NavLink>}
        <NavLink
          to="/leavetracker/mydata"
          className={({ isActive }) =>
            `px-4 py-2 font-semibold border-b-2 transition-colors ${isActive ? 'border-blue-600 text-blue-700 bg-blue-50' : 'border-transparent text-gray-700 hover:bg-gray-100'}`
          }
        >
          My Data
        </NavLink>
        <NavLink
          to="/leavetracker/holiday"
          className={({ isActive }) =>
            `px-4 py-2 font-semibold border-b-2 transition-colors ${isActive ? 'border-blue-600 text-blue-700 bg-blue-50' : 'border-transparent text-gray-700 hover:bg-gray-100'}`
          }
        >
          Holidays
        </NavLink>
      </div>
      <div>
        <Outlet />
      </div>
    </div>
  );
};

export default LeaveTrackerLayout;
